import { SpinnerProperties } from '@engie-group/fluid-types';
import { Component, h, Host, Prop } from '@stencil/core';

/**
 * Spinner allows the user to know when the system is in progress and when he will end. The spinner is used to indicate the current status of a loading screen or a loading data.
 *
 * @since 0.1.0-next.1
 * @lastmodified 0.1.0-next.1
 */
@Component({
  tag: 'nj-spinner',
})
export class Spinner implements SpinnerProperties {
  private readonly rootClass = 'nj-spinner';

  @Prop() variant: SpinnerProperties['variant'];
  @Prop() scale: SpinnerProperties['scale'];
  /**
   * Aria label, for accessibility reasons
   */
  @Prop() ariaLabel: ARIAMixin['ariaLabel'] = 'loading';

  private get classes() {
    return {
      [this.rootClass]: true,
      [`${this.rootClass}--${this.variant}`]: !!this.variant,
      [`${this.rootClass}--${this.scale}`]: !!this.scale,
    };
  }

  render() {
    return <Host class={this.classes} aria-label={this.ariaLabel}></Host>;
  }
}
